export default "__VITE_ASSET__Dsj9eX_n__"